module.exports = __webpack_public_path__ + "static/media/Ecard.599ce2e0.png";